import React from "react";
import {observer} from "mobx-react";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {BoxScoresTableViewModel} from "../models/box-scores.table.view-model";
import {BoxScoresWidgetRowPrimaryCellsTitle} from "./row-primary-cells/box-scores-widget.row-primary-cells.title";
import {BoxScoresWidgetRowPrimaryCellsMembers} from "./row-primary-cells/box-scores-widget.row-primary-cells.members";
import {BoxScoresWidgetRowPrimaryCellsSummary} from "./row-primary-cells/box-scores-widget.row-primary-cells.summary";
import {BoxScoresWidgetTableStats} from "./table-stats/box-scores-widget.table-stats";
import {BoxScoresWidgetController} from "../box-scores-widget.controller";
import classnames from "classnames";
import styles from "../styles/box-scores-widget.module.scss";

class BoxScoresWidgetTableProps extends BaseProps {
  table: BoxScoresTableViewModel;
  isExpandable: Boolean;
  isRtl: Boolean;
  isSmallView: Boolean;
  showAllStats: Boolean;
  tableCellWidth: Number;
  shouldRenderEntityImage : Boolean;
  isPlayerCardPopupVisible : Boolean;
  shouldPlayerClickable : Boolean;
  selectedAthleteId: Number;
  controller: BoxScoresWidgetController;
}

export const BoxScoresWidgetTable = observer((({table, controller}: BoxScoresWidgetTableProps) => {
  const {device, state} = controller;
  const {isExpandable ,shouldRenderEntityImage ,showAllStats, selectedTeam} = state;
  const {isSmallView} = device;
  const {name, summary, rows} = table;
  const tableProps = {
    controller,
    showAllStats,
    table,
    id: selectedTeam?.id
    // rowPrimaryCellWidth: shouldRenderEntityImage ? BOX_SCORES_WIDGET.TABLE_SIZES.rowPrimaryCellWidth : BOX_SCORES_WIDGET.TABLE_SIZES.rowPrimaryCellNoImageWidth,
  }

  const rowMemberProps = {
    rows,
    controller
  }

  return (
    <div className={classnames(styles.table_container, {[styles.expandable_table]: (isExpandable && !isSmallView) || table.columnGroups , [styles.grouped_column]: table?.columnGroups})}>
      <div className={classnames(styles.row_primary_cells_container, {[styles.row_primary_cells_row_no_images_container]: !shouldRenderEntityImage})}>
        <BoxScoresWidgetRowPrimaryCellsTitle title={name}/>
        <BoxScoresWidgetRowPrimaryCellsMembers {...rowMemberProps}/>
        <BoxScoresWidgetRowPrimaryCellsSummary summary={summary}/>
      </div>
      <BoxScoresWidgetTableStats {...tableProps} />
    </div>
  )
}));
